import { BlockType } from '../../@types/BlockType';
import { AbstractBlock } from '../AbstractBlock';
import { CodeSetting } from '../setting/CodeSetting';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';

export class LogicalOperatorBlock extends AbstractBlock {
  RIGHT = 'RIGHT';
  LEFT = 'LEFT';
  CALC = 'CALC';

  private calcurator = '';
  private calcuratorName = '';

  constructor(name: string, title: string) {
    super(name, title);
    this.calcurator = 'and'; // "or"
    this.calcuratorName = 'かつ'; // ”または”
  }

  codeGenerateCore(block: BlockType): string[] {
    const left = CodeSetting.getInputValue(block, this.LEFT);
    const right = CodeSetting.getInputValue(block, this.RIGHT);
    const str = ' (' + left + ')  ' + this.calcurator + '  (' + right + ') ';
    return [str];
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setOperatorColor(block);
    ShapeSettings.setOperatorBoolShape(block);
    // 属性値の入力フィールド
    block.appendValueInput(this.LEFT).setCheck('Boolean');
    block.appendValueInput(this.RIGHT).setCheck('Boolean').appendField(this.calcuratorName, this.CALC);
  }

  setCalcurator(calcurator: '&&' | '||', name: string): LogicalOperatorBlock {
    this.calcurator = calcurator; // "and","or"
    this.calcuratorName = name;
    return this;
  }
}
